// Adds a notification to the queue once only
const handleEnqueueNotification = (state, action) => {
  const { data } = action

  if (!data) {
    return state
  }

  // Check uniqueness
  const { id } = data
  if (state.ids.has(id)) {
    return state
  }

  // Add notification
  const newQueue = [...state.queue, data]
  const newIDs = new Set([...state.ids, id])

  return { ...state, queue: newQueue, ids: newIDs }
}

// Declares that notifications have been processed
const handleNotificationsShown = (state, _) => {
  return { ...state, queue: [] }
}

export const initialState = {
  ids: new Set(),
  queue: []
}

export const Actions = {
  ENQUEUE_NOTIFICATION: 'ENQUEUE_NOTIFICATION',
  NOTIFICATIONS_SHOWN: 'NOTIFICATIONS_SHOWN'
}

const Handlers = {
  [Actions.ENQUEUE_NOTIFICATION]: handleEnqueueNotification,
  [Actions.NOTIFICATIONS_SHOWN]: handleNotificationsShown
}

export const notificationReducer = (state, action) => {
  const { type } = action

  if (type in Handlers) {
    return Handlers[type](state, action)
  }

  throw new Error(`Unknown notification reducer type: ${type}`)
}
